import NetInfo from '@react-native-community/netinfo';
import { useEffect, useState } from 'react';
  
  export const useNetwork = () => {
    const [state, setState] = useState();
  
    useEffect(() => {
      const handleConnectivityChange = (state) =>
        setState(state);
      const unsubscribe = NetInfo.addEventListener(handleConnectivityChange);
      return unsubscribe;
    }, []);
  
    return state;
  };
  